import React from 'react'
import { number, node, bool, func } from 'prop-types'
import PointsBlock from '../PointsBlock'
import StreakBlock from '../StreakBlock/StreakBlock'

export default function PointsNStreakRow({
  streakCount,
  points,
  isStreakCurrent,
  onStreakClick,
  onPointsClick,
  children,
  isSmallScreen,
}) {
  const contentJustification = isSmallScreen ? 'space-between' : 'center'
  return (
    <div data-testid="points-n-streak-row" style={{ display: 'flex', justifyContent: contentJustification }}>
      <StreakBlock simple streakCount={streakCount ?? 0} onClick={onStreakClick} isCurrent={isStreakCurrent} />
      {children}
      <PointsBlock simple points={points ?? 0} onClick={onPointsClick} />
    </div>
  )
}

PointsNStreakRow.propTypes = {
  streakCount: number,
  points: number,
  isStreakCurrent: bool,
  onStreakClick: func,
  onPointsClick: func,
  children: node,
  isSmallScreen: bool,
}
